export default "__VITE_ASSET__DkHhIkWb__"